import React from "react";
import { Button, Form, FormGroup, Input, Label, Alert, Spinner } from "reactstrap";
import axios from "axios";
import Select, { createFilter } from "react-select";
import { API_URL_comision_multi } from "../../../constants";

import { getAuthHeaders, getCurrentUser } from "../../../utils/auth";
class AdminCursoForm extends React.Component {
  
  state = {
    pk: 0,
    errorMessage: "",
    admin_del_curso: '',
    adminCostPercentage: '',
    pago_por: 'Admin de Curso',
    iva: 0,
    retencion: 0,
    isr: 0,
    subcantidad: 0,
    cantidad: 0,
    instructor: '',
    instructor_code: '',
    comision_multi_code: '',
    moneda: '',
    tipo_cambio: null,
    proyecto_code: '',
    proyecto: '',
    mod_user: '',
    validationErrors: {}, // Track validation errors
    isSubmitting: false // Track form submission state
  };

  componentDidMount() {
    const { proyectoCode, proyectoName, proyectoMoneda, admin, ingresoProyecto } = this.props;
    const username = getCurrentUser();

    console.log('[AdminCursoForm] Props received:', { 
      proyectoCode, 
      proyectoName, 
      ingresoProyecto,
      admin 
    });

    if (admin) {
      const {
        pk,
        instructor,
        moneda,
        tipo_cambio,
        proyecto,
        proyecto_code,
        comision_multi_code,
        cantidad,
        iva,
        isr,
        retencion,
        subcantidad,
        instructor_code,
      } = admin;
      
      // When editing, calculate the percentage back from subcantidad and ingresoProyecto
      const ingreso = parseFloat(ingresoProyecto) || 0;
      const percentage = ingreso > 0 
        ? (parseFloat(subcantidad) / ingreso * 100) 
        : 0;
      
      console.log('[AdminCursoForm] Edit mode - calculated percentage:', {
        subcantidad,
        ingreso,
        percentage: percentage.toFixed(2)
      });
      
      this.setState({
        pk: pk,
        admin_del_curso: instructor,
        instructor: instructor,
        instructor_code: instructor_code || '',
        moneda: moneda || proyectoMoneda || 'USD',
        tipo_cambio: tipo_cambio ?? null,
        proyecto: proyecto,
        proyecto_code: proyecto_code,
        comision_multi_code: comision_multi_code,
        cantidad: cantidad || 0,
        iva: iva || 0,
        isr: isr || 0,
        retencion: retencion || 0,
        subcantidad: subcantidad || 0,
        adminCostPercentage: percentage.toFixed(2),
        mod_user: username,
      });
    } else {
      this.setState({
        proyecto_code: proyectoCode,
        proyecto: proyectoName,
        moneda: proyectoMoneda || 'USD',
        mod_user: username,
      });
    }
  }

  generateRandomString = (length) => {
    const characters = 'ABCDEFGHJKLMNOPQRSTUVWXYZ23456789';
    const charactersLength = characters.length;
    let random_string = '';

    for (let counter = 0; counter < length; counter++) {
      random_string += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return random_string;
  };

  validateForm = () => {
    const errors = {};
    const { admin_del_curso, adminCostPercentage } = this.state;

    if (!admin_del_curso || admin_del_curso.trim() === '') {
      errors.admin_del_curso = 'Por favor selecciona un admin del curso';
    }

    if (!adminCostPercentage || adminCostPercentage === '') {
      errors.adminCostPercentage = 'Por favor ingresa el porcentaje';
    } else if (parseFloat(adminCostPercentage) < 0 || parseFloat(adminCostPercentage) > 100) {
      errors.adminCostPercentage = 'El porcentaje debe estar entre 0 y 100';
    }

    // moneda validation removed — inherited from project

    this.setState({ validationErrors: errors });
    return Object.keys(errors).length === 0;
  };

  onChange = e => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
      // Clear validation error for this field when user types
      validationErrors: {
        ...this.state.validationErrors,
        [name]: null
      }
    });
  };

  /**
   * Prepares the payload with calculated values
   * Formula: Costo Admin = Ingreso Proyecto × (Porcentaje / 100)
   */
  preparePayload = () => {
    return new Promise((resolve) => {
      const selectedPartner = this.props.partners.find(
        partner => partner.partner === this.state.admin_del_curso
      );

      if (!selectedPartner) {
        // No partner selected, use current state
        resolve({
          ...this.state,
          cantidad: parseFloat(this.state.cantidad) || 0,
          subcantidad: parseFloat(this.state.subcantidad) || 0,
          iva: parseFloat(this.state.iva) || 0,
          retencion: parseFloat(this.state.retencion) || 0,
          isr: parseFloat(this.state.isr) || 0,
        });
        return;
      }

      const { iva, isr, retencion, partner_code, partner } = selectedPartner;
      
      // Get project income and admin percentage
      const ingresoProyecto = parseFloat(this.props.ingresoProyecto) || 0;
      const percentage = parseFloat(this.state.adminCostPercentage) || 0;
      
      // Calculate subcantidad (base cost before taxes)
      // subcantidad = ingresoProyecto × (percentage / 100)
      const subcantidad = ingresoProyecto * (percentage / 100);
      
      // Calculate cantidad (amount after taxes are applied)
      const taxFactor = (iva - retencion - isr) / 100.0;
      const cantidad = subcantidad * (1 + taxFactor);

      console.log('[AdminCursoForm] Calculation:', {
        ingresoProyecto,
        percentage,
        subcantidad,
        iva,
        retencion,
        isr,
        taxFactor: taxFactor.toFixed(4),
        cantidad: cantidad.toFixed(2)
      });

      // Update state and resolve with the complete payload
      this.setState({
        iva,
        isr,
        retencion,
        instructor_code: partner_code,
        instructor: partner,
        subcantidad,
        cantidad,
      }, () => {
        resolve({
          ...this.state,
          iva,
          isr,
          retencion,
          instructor_code: partner_code,
          instructor: partner,
          subcantidad,
          cantidad,
        });
      });
    });
  };

  createAdmin = async (e) => {
    e.preventDefault();

    // Validate form before submitting
    if (!this.validateForm()) {
      this.setState({ errorMessage: 'Por favor completa todos los campos obligatorios marcados con *' });
      // Focus first invalid field
      setTimeout(() => {
        const firstError = document.querySelector('.is-invalid-custom');
        if (firstError) {
          firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
          const input = firstError.querySelector('input, select');
          if (input) input.focus();
        }
      }, 100);
      return;
    }

    this.setState({ isSubmitting: true, errorMessage: '' });

    try {
      const headers = getAuthHeaders();
      
      // Generate random code first
      const random_string = this.generateRandomString(5);
      
      // Prepare payload with all calculated values
      const payload = await this.preparePayload();
      
      // Add the generated code to payload
      const finalPayload = {
        ...payload,
        comision_multi_code: random_string,
        // Ensure all required fields have values
        cantidad: parseFloat(payload.cantidad) || 0,
        subcantidad: parseFloat(payload.subcantidad) || 0,
        iva: parseFloat(payload.iva) || 0,
        retencion: parseFloat(payload.retencion) || 0,
        isr: parseFloat(payload.isr) || 0,
        proyecto_code: payload.proyecto_code || this.props.proyectoCode,
        proyecto: payload.proyecto || this.props.proyectoName,
        mod_user: payload.mod_user || getCurrentUser(),
        moneda: payload.moneda || 'USD',
        pago_por: 'Admin de Curso',
      };

      console.log('[DEBUG] Creating admin with payload:', finalPayload);

      const response = await axios.post(API_URL_comision_multi, finalPayload, { headers });
      
      console.log('[SUCCESS] Admin created:', response.data);

      this.props.resetState();
      this.props.toggle();

    } catch (error) {
      console.error('[ERROR] Error adding Admin:', error);

      if (error.response?.data) {
        console.error('[ERROR] Server response:', error.response.data);
        const serverErrors = error.response.data;
        if (typeof serverErrors === 'object' && !Array.isArray(serverErrors)) {
          this.setState({ validationErrors: serverErrors, isSubmitting: false });
        } else {
          const errorMessages = Object.entries(error.response.data)
            .map(([field, messages]) => `${field}: ${Array.isArray(messages) ? messages.join(', ') : messages}`)
            .join('\n');
          this.setState({ errorMessage: `Error: ${errorMessages}`, isSubmitting: false });
        }
      } else {
        this.setState({ errorMessage: 'Error de conexión. Por favor intenta nuevamente.', isSubmitting: false });
      }
    }
  };

  editAdmin = async (e) => {
    e.preventDefault();

    // Validate form before submitting
    if (!this.validateForm()) {
      this.setState({ errorMessage: 'Por favor completa todos los campos obligatorios marcados con *' });
      // Focus first invalid field
      setTimeout(() => {
        const firstError = document.querySelector('.is-invalid-custom');
        if (firstError) {
          firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
          const input = firstError.querySelector('input, select');
          if (input) input.focus();
        }
      }, 100);
      return;
    }

    this.setState({ isSubmitting: true, errorMessage: '' });

    try {
      const headers = getAuthHeaders();

      // Prepare payload with calculated values
      const payload = await this.preparePayload();
      
      const finalPayload = {
        ...payload,
        // Ensure numeric fields are properly typed
        cantidad: parseFloat(payload.cantidad) || 0,
        subcantidad: parseFloat(payload.subcantidad) || 0,
        iva: parseFloat(payload.iva) || 0,
        retencion: parseFloat(payload.retencion) || 0,
        isr: parseFloat(payload.isr) || 0,
      };

      console.log('[DEBUG] Updating admin with payload:', finalPayload);

      const response = await axios.put(
        `${API_URL_comision_multi}${this.state.pk}/`,
        finalPayload, 
        { headers }
      );
      
      console.log('[SUCCESS] Admin updated:', response.data);

      this.props.resetState();
      this.props.toggle();

    } catch (error) {
      console.error('[ERROR] Error updating Admin:', error);

      if (error.response?.data) {
        console.error('[ERROR] Server response:', error.response.data);
        const serverErrors = error.response.data;
        if (typeof serverErrors === 'object' && !Array.isArray(serverErrors)) {
          this.setState({ validationErrors: serverErrors, isSubmitting: false });
        } else {
          const errorMessages = Object.entries(error.response.data)
            .map(([field, messages]) => `${field}: ${Array.isArray(messages) ? messages.join(', ') : messages}`)
            .join('\n');
          this.setState({ errorMessage: `Error: ${errorMessages}`, isSubmitting: false });
        }
      } else {
        this.setState({ errorMessage: 'Error de conexión. Por favor intenta nuevamente.', isSubmitting: false });
      }
    }
  };

  render() {
    const { errorMessage, admin_del_curso, adminCostPercentage, moneda, subcantidad, iva, retencion, isr, validationErrors, isSubmitting } = this.state;
    const { proyectoCode, proyectoName, partners, ingresoProyecto } = this.props;
    const h3Style = { color: 'blue' };

    // Parse values safely
    const ingreso = parseFloat(ingresoProyecto) || 0;
    const percentage = parseFloat(adminCostPercentage) || 0;

    // Calculate admin cost: Ingreso × (Percentage / 100)
    const costoBase = ingreso * (percentage / 100);

    // Calculate with taxes
    const currentTaxFactor = (parseFloat(iva) - parseFloat(retencion) - parseFloat(isr)) / 100.0;
    const costoTotal = costoBase * (1 + currentTaxFactor);

    console.log('[AdminCursoForm] Render:', {
      ingreso,
      percentage,
      costoBase: costoBase.toFixed(2),
      taxFactor: currentTaxFactor.toFixed(4),
      costoTotal: costoTotal.toFixed(2)
    });

    // Filter option for react-select (search without accents)
    const filterOption = createFilter({
      ignoreAccents: true,
      ignoreCase: true,
      trim: true,
      matchFrom: "any",
    });

    // Options for Select components
    const partnerOptions = Array.isArray(partners)
      ? partners.map(partner => ({ value: partner.partner, label: partner.partner }))
      : [];

    const fxRowCurrency = moneda || 'USD';
    const fxProjectCurrency = this.props.proyectoMoneda || 'USD';
    const fxCurrency = fxRowCurrency !== 'USD' ? fxRowCurrency : fxProjectCurrency;
    const showTipoCambio = fxRowCurrency !== 'USD' || fxProjectCurrency !== 'USD';

    return (
      <div>
        <h3>{proyectoName}</h3>
        {proyectoCode && <h3 style={h3Style}>{proyectoCode.toUpperCase()}</h3>}

        {/* Show Project Income */}
        <div style={{
          padding: '10px',
          marginBottom: '15px',
          backgroundColor: '#e3f2fd',
          borderRadius: '5px',
          border: '1px solid #2196f3'
        }}>
          <strong>Ingreso del Proyecto:</strong>{' '}
          <span style={{ fontSize: '1.1em', color: '#1976d2' }}>
            {ingreso > 0
              ? ingreso.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                })
              : '0.00 (no disponible)'
            }
          </span>
          {ingreso === 0 && (
            <div style={{ color: '#d32f2f', fontSize: '0.9em', marginTop: '5px' }}>
              ⚠️ Advertencia: El ingreso del proyecto es 0. Verifica que se haya pasado correctamente.
            </div>
          )}
        </div>

        <div className="form-requirements-note">
          <strong>Nota:</strong> Los campos marcados con <span className="required-asterisk">*</span> son obligatorios.
        </div>

        <Form onSubmit={this.props.admin ? this.editAdmin : this.createAdmin}>
          <FormGroup>
            <Label for="admin_del_curso">
              Admin del Curso<span className="required-asterisk">*</span>
            </Label>
            <Select
              options={partnerOptions}
              value={partnerOptions.find((o) => o.value === admin_del_curso) || null}
              onChange={(opt) => {
                this.setState({
                  admin_del_curso: opt ? opt.value : "",
                  validationErrors: {
                    ...validationErrors,
                    admin_del_curso: null
                  }
                });
              }}
              placeholder="Seleccionar Admin..."
              isClearable
              filterOption={filterOption}
              className={validationErrors.admin_del_curso ? 'is-invalid' : ''}
            />
            {validationErrors.admin_del_curso && (
              <div className="invalid-feedback-custom">{validationErrors.admin_del_curso}</div>
            )}
          </FormGroup>

          <FormGroup>
            <Label for="adminCostPercentage">
              Porcentaje (%)<span className="required-asterisk">*</span>
            </Label>
            <Input
              type="number"
              name="adminCostPercentage"
              onChange={this.onChange}
              value={adminCostPercentage}
              step="0.01"
              min="0"
              max="100"
              placeholder="Ej: 10 para 10%"
              className={validationErrors.adminCostPercentage ? 'is-invalid-custom' : ''}
            />
            {validationErrors.adminCostPercentage && (
              <div className="invalid-feedback-custom">{validationErrors.adminCostPercentage}</div>
            )}
            <small className="form-text text-muted">
              El costo de administración será: {ingreso.toLocaleString()} × {percentage}% = {costoBase.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
            </small>
          </FormGroup>

          <FormGroup>
            <Label for="moneda">Moneda (desde proyecto):</Label>
            <Input
              type="text"
              name="moneda"
              value={moneda || 'USD'}
              disabled
              style={{ backgroundColor: '#f0f0f0', cursor: 'not-allowed' }}
            />
            <small className="form-text text-muted">
              La moneda se hereda del proyecto y no se puede cambiar aquí
            </small>
          </FormGroup>

          {showTipoCambio && (
            <FormGroup>
              <Label for="tipo_cambio">
                Tipo de Cambio ({fxCurrency} por 1 USD):
              </Label>
              <Input
                type="number"
                step="0.0001"
                min="0"
                name="tipo_cambio"
                placeholder="ej. 17 (vacío para usar la tasa mensual)"
                onChange={(e) => this.setState({
                  tipo_cambio: e.target.value === "" ? null : Number(e.target.value),
                })}
                value={this.state.tipo_cambio ?? ""}
              />
              <small className="form-text text-muted">
                {fxRowCurrency !== 'USD'
                  ? 'Opcional. Si lo capturas, esta partida se convierte a USD dividiendo entre este número. Vacío = tasa del mes de inicio del proyecto.'
                  : `Opcional. Si lo capturas, esta partida en USD se convierte a ${fxProjectCurrency} multiplicando por este número. Vacío = tasa del mes de inicio del proyecto.`}
              </small>
            </FormGroup>
          )}

          {costoBase > 0 && (
            <FormGroup>
              <Label>Costo de Administración:</Label>
              <div style={{ 
                padding: '15px', 
                backgroundColor: '#f1f8e9', 
                borderRadius: '5px',
                border: '1px solid #8bc34a'
              }}>
                <div style={{ fontSize: '1.1em', marginBottom: '10px' }}>
                  <strong>Costo Base (subcantidad):</strong>{' '}
                  <span style={{ color: '#558b2f' }}>
                    {costoBase.toLocaleString(undefined, { 
                      minimumFractionDigits: 2, 
                      maximumFractionDigits: 2 
                    })}
                  </span>
                </div>
                
                {(iva > 0 || retencion > 0 || isr > 0) && (
                  <div style={{ fontSize: '0.9em', color: '#666' }}>
                    <div>• IVA: {iva}%</div>
                    <div>• Retención: {retencion}%</div>
                    <div>• ISR: {isr}%</div>
                    <div style={{ marginTop: '5px' }}>
                      Factor neto: {(currentTaxFactor * 100).toFixed(2)}%
                    </div>
                    <div style={{ 
                      marginTop: '10px', 
                      paddingTop: '10px', 
                      borderTop: '1px solid #aed581',
                      fontSize: '1.1em'
                    }}>
                      <strong>Costo Total (cantidad):</strong>{' '}
                      <span style={{ color: '#33691e', fontWeight: 'bold' }}>
                        {costoTotal.toLocaleString(undefined, { 
                          minimumFractionDigits: 2, 
                          maximumFractionDigits: 2 
                        })}
                      </span>
                    </div>
                  </div>
                )}
              </div>
            </FormGroup>
          )}
          
          {errorMessage && (
            <Alert color="danger">
              <pre style={{ whiteSpace: 'pre-wrap', fontSize: '0.9em' }}>
                {errorMessage}
              </pre>
            </Alert>
          )}

          <Button color="primary" disabled={isSubmitting}>
            {isSubmitting ? (
              <>
                <Spinner size="sm" className="me-2" /> Guardando...
              </>
            ) : (
              'Guardar'
            )}
          </Button>
        </Form>
      </div>
    );
  }
}

export default AdminCursoForm;